import * as Dialog from '@radix-ui/react-dialog';
import { Button } from '@/components/ui/Button';
import { faengtAussenklickAb } from '@/onboarding/tourSchutz';
import type { VerlassenWarnungArt } from '@/lib/verlassenWarnung';

// Die Nachfrage beim Verlassen einer fertigen Bestellung (lib/verlassenWarnung.ts).
//
// Drei Antworten, alle gleich erreichbar:
//   - der nächste Schritt (abschließen bzw. abholbereit setzen), dann weiter
//   - „Später": weiter, ohne etwas zu ändern — und in dieser Sitzung
//     nicht noch einmal fragen
//   - „Hierbleiben": die Bestellung bleibt offen, nichts passiert

export function VerlassenWarnung({
  offen,
  art,
  laeuft,
  onSchritt,
  onSpaeter,
  onBleiben
}: {
  offen: boolean;
  art: VerlassenWarnungArt;
  laeuft: boolean;
  onSchritt: () => void;
  onSpaeter: () => void;
  onBleiben: () => void;
}) {
  const versand = art === 'versand';
  return (
    <Dialog.Root open={offen} onOpenChange={(o) => !o && onBleiben()}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-50 bg-ink/30" />
        <Dialog.Content
          onPointerDownOutside={faengtAussenklickAb}
          onInteractOutside={faengtAussenklickAb}
          aria-describedby={undefined}
          className="fixed left-1/2 top-1/2 z-50 w-[min(480px,90vw)] -translate-x-1/2 -translate-y-1/2 rounded-md border-2 border-coral bg-cream p-5 shadow-lg"
        >
          <Dialog.Title className="font-serif text-lg text-ink">
            {versand ? 'Alles ist da. Rechnung schon geschrieben?' : 'Alles ist da. Abholbereit setzen?'}
          </Dialog.Title>
          <p className="mt-2 text-sm text-ink-soft">
            {versand
              ? 'Diese Bestellung steht noch auf „Eingetroffen". Wenn die Rechnung in BONUS geschrieben ist, kann sie abgeschlossen werden.'
              : 'Diese Bestellung steht noch auf „Eingetroffen". Liegt sie schon im Regal, gehört sie auf „Abholbereit".'}
          </p>
          <div className="mt-5 flex flex-wrap justify-end gap-2">
            <Button variant="ghost" onClick={onBleiben} disabled={laeuft}>
              Hierbleiben
            </Button>
            <Button variant="secondary" onClick={onSpaeter} disabled={laeuft}>
              Später
            </Button>
            <Button variant="primary" onClick={onSchritt} disabled={laeuft}>
              {versand ? 'Jetzt abschließen' : 'Abholbereit setzen'}
            </Button>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
